export const exportGrainSpecsToCalculator = (
  specs: IObj[],
  weight: number,
): IResult => {
  const res: any = {
    weight: weight,
    temperature: specs.find((item) => item.name === 'Температура')?.value,
    gluten: specs.find((item) => item.name === 'Клейковина')?.value,
    idk: specs.find((item) => item.name === 'ИДК')?.value,
    bug: 0, //specs.find((item) => item.name === '')?.value,
    protein: specs.find((item) => item.name === 'Протеин')?.value,
    cp: specs.find((item) => item.name === 'Число падения')?.value,
    nature: specs.find((item) => item.name === 'Натура')?.value,
    humidity: specs.find((item) => item.name === 'Влажность культуры')?.value,
    wheatType: specs.find((item) => item.name === 'Тип')?.value,
  };

  Object.values(res).map((value) => (value ? value.toString() : '0'));

  return res;
};

export interface IObj {
  name: string;
  value: number;
  units: string;
}

interface IResult {
  weight: string;
  gluten: string;
  idk: string;
  bug: string;
  protein: string;
  cp: string;
  nature: string;
  humidity: string;
  temperature: string;
  wheatType: string;
}
